import React from 'react'
import { Box, Flex, Spinner, Text } from '@chakra-ui/react'

import {
    FilterOp,
    ScheduledMessageStatus,
    useQueryScheduledMessagesQuery,
} from '~graphql/generated/graphql'
import ScheduledMessageRow from './scheduled-message-row'

interface Props {
    chatId: string
    clinicId: string
}

export default function ScheduledMessagesBanner({ chatId, clinicId }: Props) {
    const { data, loading, refetch } = useQueryScheduledMessagesQuery({
        variables: {
            where: [
                {
                    column: 'chat',
                    filterOp: FilterOp.Eq,
                    value: { string: chatId },
                },
                {
                    column: 'clinic',
                    filterOp: FilterOp.Eq,
                    value: { string: clinicId },
                },
                {
                    column: 'status',
                    filterOp: FilterOp.Eq,
                    value: { string: ScheduledMessageStatus.Pending },
                },
            ],
            orderBy: { column: 'send_time', isAscending: true },
            pageSize: 20,
        },
        fetchPolicy: 'cache-and-network',
        pollInterval: 60_000,
    })

    const messages = data?.queryScheduledMessages ?? []

    if (loading && !data) {
        return (
            <Box px={4} py={1}>
                <Spinner size="xs" color="brand.400" />
            </Box>
        )
    }

    if (messages.length === 0) return null

    return (
        <Flex flexDir="column" gap={1} px={4} pb={2}>
            <Text fontSize="2xs" fontWeight="semibold" color="gray.400" pl={1}>
                SCHEDULED
            </Text>
            {messages.map(msg => (
                <ScheduledMessageRow
                    key={msg.id}
                    message={msg}
                    onCancelled={refetch}
                />
            ))}
        </Flex>
    )
}
